
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
// import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import Alert from '@mui/material/Alert';
import { Box, IconButton, Modal, Typography, Card, Grid, TextField, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import RegisterAccess from "../../utils/registerAccess";
import api from "../../services/api";
import MessageSuccess from "../../messages/messageSuccess";
import MessageError from "../../messages/messageError";
import ButtonLeft from "../../utils/buttonLeft";

const ExpedienteForm = ({ open = false }) => {

    const [docExpediente, setDocExpediente] = useState({
        portador: '',
        requerente: '',
        tipoRemetente: '',
        nifBi: '',
        assunto: '',
        dataDoc: '',
        tel: '',
        email: '',
        anexo: '',
        tipoDoc: '',
        descricao: '',
        remetidoPorTel: '',
        remetidoPorEmail: '',
        remetentoPorBi: '',
        anexoBi: '',
    })
    const [message, setMessage] = useState('')
    const [messageError, seterrorMessage] = useState('')
    const [tipoDocumento, setTipoDocumento] = useState([])
    // const [response, setResponse] = useState(false);
    const [openExpendiente, setOpenExpendiente] = useState(false)
    const [load, setLoad] = useState(false)
    const navigate = useNavigate()
    const { action } = useParams()

    const handleOpenExpediente = () => setOpenExpendiente(true);
    const handleCloseExpediente = () => setOpenExpendiente(false);

    useEffect(() => {
        setOpenExpendiente(open)
    }, [open])

    useEffect(() => {
        if (action === 'expediente') {
            handleOpenExpediente();
            setMessage('');
            setDocExpediente({
                portador: '',
                requerente: '',
                tipoRemetente: '',
                nifBi: '',
                assunto: '',
                tel: '',
                email: '',
                anexo: '',
                tipoDoc: '',
                descricao: '',
                remetidoPorTel: '',
                remetidoPorEmail: '',
                remetentoPorBi: '',
                anexoBi: '',
            });
        }
    }, [action])

    useEffect(() => {
        api.get('/expediente-docs')
            .then((res) => {
                setTipoDocumento(res.data.expedienteDocss)
            })
            .catch((err) => seterrorMessage('Ocorreu algum problema ao pegar os Documentos'))
    }, [])

    function HandleChange(e) {
        e.target.files ?
            setDocExpediente({ ...docExpediente, [e.target.name]: e.target.files[0] })
            :
            setDocExpediente({ ...docExpediente, [e.target.name]: e.target.value })
    }

    async function createReclamacao() {
        const formData = new FormData();
        formData.append('tipoRemetente', docExpediente.tipoRemetente);
        formData.append('nome', docExpediente.portador);
        formData.append('email', docExpediente.email);
        formData.append('nifBi', docExpediente.nifBi);
        formData.append('tel', docExpediente.tel);
        formData.append('descricao', docExpediente.descricao);
        formData.append('assunto', docExpediente.assunto);
        formData.append('tipoDocumentoId', docExpediente.tipoDoc);
        formData.append('remetidoPorNome', docExpediente.requerente);
        formData.append('remetidoPorTel', docExpediente.remetidoPorTel);
        formData.append('remetidoPorEmail', docExpediente.remetidoPorEmail);
        formData.append('remetidoPorBi', docExpediente.remetentoPorBi);
        formData.append('anexo', docExpediente.anexo);
        formData.append('remetidoPorAnexoBi', docExpediente.anexoBi);

        setLoad(true)
        seterrorMessage('')
        setMessage('')

        await api.post('/expediente/create', formData)
            .then(res => {
                setLoad(false)
                setMessage(res.data.msg)
            }).catch(error => {
                seterrorMessage(error.response.data.message)
                setLoad(false)
            })
    }
    return (
        <div>
            <RegisterAccess page={'Expediente'} />

            <Modal
                open={openExpendiente}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{ margin: 2 }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: { xs: "100%", sm: 700 },
                        height: "auto",
                        maxHeight: "90vh",
                        bgcolor: "background.paper",
                        border: "2px solid #85287E",
                        boxShadow: 24,
                        overflowY: "auto",
                        borderRadius: 2,
                    }}
                >
                    <IconButton color='error' title="fechar" style={{ position: 'absolute', right: 5, fontWeight: 'bold' }} onClick={() => { handleCloseExpediente(); !open && navigate(-1) }}> <CloseIcon /></IconButton>
                    {message && <MessageSuccess message={message} />}
                    {messageError && <MessageError message={messageError} />}

                    <Typography align="center" >
                        <img src="/icones/iconExpediente-03.svg" width={80} style={{ margin: 10 }} />
                        <br />
                        ENTRADA DE DOCUMENTOS
                    </Typography>

                    {!message &&
                        <Card style={{ padding: 20 }}>
                            <Typography align="left" style={{ textTransform: 'uppercase' }}>
                                Dados do Representante
                            </Typography>
                            <Grid xs={12} md item >
                                <TextField
                                    margin="dense"
                                    type="text"
                                    label="Requerente / Nome"
                                    fullWidth
                                    size="small"
                                    name="requerente"
                                    variant="outlined"
                                    onChange={HandleChange}
                                />
                            </Grid>

                            <Grid xs={12} md item style={{
                                display: 'flex',
                                gap: '10px'
                            }}>
                                <TextField
                                    margin="dense"
                                    type="number"
                                    label="Tel."
                                    size="small"
                                    name="remetidoPorTel"
                                    variant="outlined"
                                    onChange={HandleChange}
                                    style={{ width: '50%' }}
                                />

                                <TextField
                                    margin="dense"
                                    type="email"
                                    label="Email"
                                    fullWidth
                                    size="small"
                                    name="remetidoPorEmail"
                                    variant="outlined"
                                    onChange={HandleChange}
                                    style={{ width: '50%' }}
                                />
                            </Grid>

                            <Grid xs={12} md item >
                                <TextField
                                    margin="dense"
                                    type="text"
                                    label="Nº BI"
                                    fullWidth
                                    size="small"
                                    name="remetentoPorBi"
                                    variant="outlined"
                                    onChange={HandleChange}
                                />
                            </Grid>
                            <Grid xs={12} md item >
                                <div style={{ border: '1px dashed', borderRadius: 5, marginTop: 10 }}>
                                    <label htmlFor="anexoBi" style={{ margin: 5, cursor: 'pointer' }} >

                                        {docExpediente?.anexoBi ?
                                            <>
                                                <Typography variant="subtitle2" title="Alterar">
                                                    <Alert severity="success">
                                                        {docExpediente?.anexoBi?.name}
                                                    </Alert>
                                                </Typography>
                                                <img src={URL.createObjectURL(docExpediente?.anexoBi)} alt="" width={'25%'} />
                                            </>
                                            :
                                            <Typography variant="subtitle2" align="center" style={{ fontSize: '16px' }}>
                                                Anexar BI
                                            </Typography>
                                        }
                                    </label>
                                    <input accept="application/pdf, image/png, image/jpg, image/jpeg" type="file" name="anexoBi" id="anexoBi" style={{ display: 'none' }} onChange={HandleChange} />
                                </div>
                            </Grid>

                            <Typography align="left" style={{ marginTop: '20px', textTransform: 'uppercase' }}>
                                Dados do Remetente
                            </Typography>
                            <Grid xs={12} md item >
                                <TextField
                                    margin="dense"
                                    type="text"
                                    label="Portador / Remetente"
                                    fullWidth
                                    size="small"
                                    name="portador"
                                    variant="outlined"
                                    onChange={HandleChange}
                                />
                            </Grid>

                            <Grid xs={12} md item >
                                <FormControl fullWidth margin="dense">
                                    <InputLabel id="demo-simple-select-label">Tipo Remetente</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        type="text"
                                        label="Tipo Remetente"
                                        size="small"
                                        name="tipoRemetente"
                                        onChange={HandleChange}
                                    >
                                        <MenuItem value='Instituição'>
                                            Instituição
                                        </MenuItem>
                                        <MenuItem value='Empresa'>
                                            Empresa
                                        </MenuItem>
                                        <MenuItem value='Singular'>
                                            Singular
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid xs={12} md item style={{
                                display: 'flex',
                                gap: '10px'
                            }}>
                                <TextField
                                    margin="dense"
                                    type="text"
                                    label="NIF / Nº B.I"
                                    size="small"
                                    name="nifBi"
                                    variant="outlined"
                                    onChange={HandleChange}
                                    style={{ width: '50%' }}
                                />

                                <FormControl style={{ width: '50%' }} margin="dense">
                                    <InputLabel id="demo-simple-select-label">Tipo de Documento</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        type="text"
                                        label="Tipo de Documento"
                                        size="small"
                                        name="tipoDoc"
                                        onChange={HandleChange}
                                    >
                                        {tipoDocumento.map((documento) => (
                                            <MenuItem value={documento?._id}>
                                                {documento?.designacao}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid xs={12} md item style={{
                                display: 'flex',
                                gap: '10px'
                            }}>
                                {/* <TextField
                                    margin="dense"
                                    type="date"
                                    label="Data do Documento"
                                    size="small"
                                    name="dataDoc"
                                    variant="outlined"
                                    onChange={HandleChange}
                                    InputLabelProps={{ shrink: true }}
                                    style={{ width: '50%' }}
                                /> */}
                                <TextField
                                    margin="dense"
                                    type="number"
                                    label="Tel."
                                    size="small"
                                    name="tel"
                                    variant="outlined"
                                    onChange={HandleChange}
                                    style={{ width: '50%' }}
                                />

                                <TextField
                                    margin="dense"
                                    type="email"
                                    label="Email"
                                    fullWidth
                                    size="small"
                                    name="email"
                                    variant="outlined"
                                    onChange={HandleChange}
                                    style={{ width: '50%' }}
                                />
                            </Grid>

                            <Grid xs={12} md item style={{
                                display: 'flex',
                                gap: '10px'
                            }}>
                                <TextField
                                    margin="dense"
                                    type="text"
                                    label="Assunto"
                                    fullWidth
                                    size="small"
                                    name="assunto"
                                    variant="outlined"
                                    onChange={HandleChange}
                                />
                            </Grid>
                            <Grid xs={12} md item >
                                <TextField
                                    margin="dense"
                                    type="text"
                                    label="Descrever"
                                    fullWidth
                                    size="small"
                                    multiline
                                    minRows={2}
                                    name="descricao"
                                    variant="outlined"
                                    onChange={HandleChange}
                                />
                            </Grid>
                            <Grid xs={12} md item >
                                <div style={{ border: '1px dashed', borderRadius: 5, marginTop: 10}}>
                                    <label htmlFor="anexo" style={{ margin: 5, cursor: 'pointer' }} >

                                        {docExpediente?.anexo ?
                                            <>
                                                <Typography variant="subtitle2" title="Alterar">
                                                    <Alert severity="success">
                                                        {docExpediente?.anexo?.name}
                                                    </Alert>
                                                </Typography>
                                                <img src={URL.createObjectURL(docExpediente?.anexo)} alt="" width={'25%'} />
                                            </>
                                            :
                                            <Typography variant="subtitle2" align="center" style={{fontSize: '16px' }}>
                                                Anexo
                                            </Typography>
                                        }
                                    </label>
                                    <input accept="application/pdf, image/png, image/jpg, image/jpeg" type="file" name="anexo" id="anexo" style={{ display: 'none' }} onChange={HandleChange} />
                                </div>
                                <ButtonLeft load={load} title={'Submeter'} funcao={createReclamacao} disabled={load} children={undefined} />
                            </Grid>
                        </Card>
                    }

                    {message &&
                        <Card style={{ padding: 10, marginTop: 20 }}>
                            <Typography style={{ margin: 20 }} align="center">
                                <CheckCircleOutlineIcon fontSize="large" color="success" />
                                <br />
                                {message}
                            </Typography>
                        </Card>
                    }
                </Box>
            </Modal>
        </div>
    )
}

export default ExpedienteForm
